'use strict';

var $cache = {
    vtoWidget: null,
    fittingboxContainer: null
};

var fitmixReadyPromise = null;

/**
 * Update cache with current DOM elements
 */
function updateCache() {
    $cache.vtoWidget = $('#VTOWidget');
    $cache.fittingboxContainer = $('.fittingbox-container');
}

/**
 * Open VTO module
 */
async function openVto() {
    await stopVto();
    await initFittingBoxVTO();
    if (window.fitmixInstance) {
        if ($cache.vtoWidget.length) {
            $cache.vtoWidget.show();
            window.fitmixInstance.startVto('live');
        }
    }
}

/**
 * Stop VTO module
 */
async function stopVto() {
    if (window.fitmixInstance) {
        window.fitmixInstance.stopVto();
        await window.fitmixInstance.remove();
        delete window.fitmixInstance;
    }
    return Promise.resolve();
}

/**
 * Load FitMix library dynamically
 * @param {string} libraryURL - URL of the FitMix library
 * @returns {Promise} Promise that resolves when library is loaded
 */
function loadFitMixLibrary(libraryURL) {
    return new Promise(function (resolve, reject) {
        if (fitmixReadyPromise) {
            return resolve();
        }

        if (typeof FitMix !== 'undefined') {
            resolve();
            return;
        }

        if (!libraryURL) {
            reject(new Error('FitMix library URL is empty'));
            return;
        }

        // Check if script is already being loaded
        var existingScript = $('script[src="' + libraryURL + '"]');
        if (existingScript.length) {
            var checkExisting = setInterval(function () {
                if (typeof FitMix !== 'undefined') {
                    clearInterval(checkExisting);
                    resolve();
                }
            }, 100);

            setTimeout(function () {
                clearInterval(checkExisting);
                if (typeof FitMix === 'undefined') {
                    reject(new Error('FitMix library failed to load'));
                }
            }, 10000);
            return;
        }

        // Create and load script
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = libraryURL;
        script.onload = function () {
            resolve();
        };
        script.onerror = function () {
            console.error('Failed to load FitMix library from:', libraryURL);
            reject(new Error('Failed to load FitMix library'));
        };
        document.head.appendChild(script);
    });
}

/**
 * Ensure FitMix is loaded and the widget instance is created
 * @param {string} libraryURL - URL of the FitMix library
 * @param {string} frameId - FittingBox frame id
 * @returns {Promise} Promise that resolves when instance is ready
 */
async function ensureFitMixReady(libraryURL, frameId) {
    if (window.fitmixInstance) {
        if (frameId) {
            window.fitmixInstance.setFrame(frameId);
        }
        return true;
    }

    try {
        fitmixReadyPromise = await loadFitMixLibrary(libraryURL);

        var $widget = $cache.vtoWidget;
        if (!$widget.length) {
            throw new Error('VTOWidget not found in DOM');
        }

        var apiKey = $widget.attr('data-api-key');
        var privacyConfig = $widget.attr('data-privacy-config');

        if (!apiKey || apiKey.trim() === '') {
            throw new Error('FitMix API key is missing or empty');
        }

        var privacyConfigObj = {};
        if (privacyConfig && privacyConfig.trim() !== '') {
            try {
                privacyConfigObj = JSON.parse(privacyConfig);
            } catch (e) {
                console.warn('Failed to parse privacy config, using empty object:', e);
                privacyConfigObj = {};
            }
        }

        window.fitmixParams = {
            apiKey: apiKey,
            onStopVto: () => true,
            dataPrivacyDisclaimerTexts: privacyConfigObj
        };

        if (frameId) {
            window.fitmixParams.frame = frameId;
        }

        return new Promise(function (resolve) {
            window.fitmixInstance = FitMix.createWidget('VTOWidget', window.fitmixParams, function () {
                resolve();
            });
        });
    } catch (error) {
        console.error('Failed to load FitMix library:', error);
        throw error;
    }
}

/**
 * Initialize VTO for FittingBox
 */
async function initFittingBoxVTO() {
    // Update cache first
    updateCache();

    // Check if FittingBox VTO is available
    if (!$cache.fittingboxContainer.length || !$cache.vtoWidget.length) {
        return;
    }

    var fittingboxId = $cache.fittingboxContainer.attr('data-fittingbox-id');

    if (!fittingboxId || fittingboxId.length === 0) {
        return;
    }

    // Get library URL from data attribute
    var libraryURL = $cache.vtoWidget.attr('data-library-url');

    if (!libraryURL) {
        console.error('FitMix library URL is missing from VTOWidget data attribute');
        return;
    }

    var $carouselContainer = $cache.fittingboxContainer.closest('.carousel-container');
    if (!$carouselContainer.length) {
        $carouselContainer = $('.carousel-container');
    }

    var $fittingboxThumb = $carouselContainer.find('.slick-paging-btn.slick-paging-3d');
    if ($fittingboxThumb.length) {
        $fittingboxThumb.prop('disabled', true).addClass('fitmix-loading');
    }

    // Preload library + create widget early so user click can start camera immediately
    try {
        await ensureFitMixReady(libraryURL, fittingboxId);
        if ($fittingboxThumb.length) {
            $fittingboxThumb.prop('disabled', false).removeClass('fitmix-loading');
        }
    } catch (error) {
        console.error('Failed to initialize FitMix:', error);
    }
}

module.exports = {
    openVto: function () {
        openVto();
    },
    stopVto: function () {
        stopVto();
    }
};
